import React from 'react';
import Button from '../../components/button';

import handleChat from '../../utils/handle-chat';

const features = [
  {
    name: '商品卡片',
    price: '10元/月'
  },
  {
    name: '品牌独立',
    price: '10元/月'
  },
  {
    name: '卡片消息',
    price: '10元/月'
  },
  {
    name: 'API',
    price: '10元/月'
  },
  {
    name: '智能引导',
    price: '20元/月'
  },
  {
    name: '数据大屏',
    price: '20元/月'
  },
  {
    name: '聊天机器人',
    price: '150元/月'
  },
  {
    name: '专属服务',
    price: '赠送'
  },
  {
    name: '客户成功',
    price: '赠送'
  },
  {
    name: '技术支持',
    price: '赠送'
  }
];

const Price3 = () => {
  return (
    <div className="price-wrapper price3">
      <div className="price-header">
        <p>
          全功能套餐<i className="tag">5折优惠</i>
        </p>
        <p>无限坐席</p>
      </div>
      <div className="price-content">
        <p className="font-24">¥11988元/年</p>
        <p className="count-price">
          <span className="font-36">￥</span>
          <span className="font-68">7188</span>
          <span className="font-16">元/年</span>
        </p>
        <div className="btn">
          <Button type="primary" onClick={() => handleChat('立即购买全功能套餐', ['d9', 'type1'])}>
            立即购买
          </Button>
        </div>
        <p className="desc">
          包含 <i className="tag">进阶套餐</i> 功能，以及
        </p>
        <ul>
          {features.map((f, i) => (
            <li key={i} className={f.price === '赠送' ? 'gift' : ''}>
              <span>
                <span className="dot" />
                {f.name}
              </span>
              <span>{f.price}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="price-btn">
        <Button onClick={() => handleChat('免费试用全功能套餐', ['d9', 'type2'])}>免费试用</Button>
      </div>
    </div>
  );
};

export default Price3;
